import { useState } from 'react';
import { Button } from '@mui/material';
import PolicyOutlinedIcon from '@mui/icons-material/PolicyOutlined';
import { useSnackbar } from 'notistack';
import { getInsurancePolicyPdf, openInsurancePdf } from '../../api/endpoints/insurance';
import { ApiError } from '../../api/types/common';

/**
 * Rezervasyon detayında, sepetinde Tamamlıyo sigortası (`travelInsurances[0]`) olan bir
 * uçuş kaydı için "Poliçe PDF" aksiyonu. `Insurance/PolicyPDF` `teklifId` ile çalışır
 * (= `TravelInsurance.id`); `rawPdfContent` base64 → yeni sekmede aç / indir.
 */
export function InsurancePolicyButton({ teklifId }: { teklifId: string }) {
  const { enqueueSnackbar } = useSnackbar();
  const [busy, setBusy] = useState(false);

  const open = async () => {
    setBusy(true);
    try {
      const res = await getInsurancePolicyPdf(teklifId);
      if (!res.rawPdfContent) throw new Error('Poliçe içeriği boş döndü.');
      openInsurancePdf(res.rawPdfContent, `police-${teklifId}.pdf`);
    } catch (err) {
      enqueueSnackbar(
        err instanceof ApiError || err instanceof Error ? err.message : 'Poliçe alınamadı.',
        { variant: 'error' }
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      variant="outlined"
      size="small"
      startIcon={<PolicyOutlinedIcon />}
      disabled={busy}
      onClick={open}
    >
      {busy ? 'Alınıyor…' : 'Poliçe PDF'}
    </Button>
  );
}
